import React from 'react';

const DisclaimerPage: React.FC = () => {
  return (
    <div style={{ maxWidth: '800px', margin: '0 auto', padding: '20px' }}>
      <h1>Disclaimer</h1>
      <p>Last updated: May 19, 2025</p>
      
      <p>The information provided by AskCEO.ai is for general informational purposes only. All information is provided in good faith; however, we make no representation or warranty of any kind, express or implied, regarding the accuracy, adequacy, validity, reliability, availability, or completeness of any information.</p>
      
      <p>Our location analysis, demographic insights, and business recommendations are based on data from various sources and AI-powered algorithms. While we strive to provide accurate and useful information, AskCEO.ai does not guarantee the success of any business venture or location decision. Business outcomes depend on numerous factors beyond our control, including but not limited to market conditions, management execution, competition, and economic changes.</p>
      
      <p>Users should conduct their own due diligence and seek professional advice before making significant business or investment decisions. AskCEO.ai is a decision support tool and should not replace professional judgment, local market knowledge, or industry expertise.</p>
      
      <p>Under no circumstance shall AskCEO.ai have any liability to you for any loss or damage incurred as a result of the use of the platform or reliance on any information provided. Your use of AskCEO.ai and its services is solely at your own risk.</p>
      
      <h2>Contact Us</h2>
      <p>If you have any questions about this Disclaimer, you can contact us:</p>
      <ul>
        <li>By email: <a href="mailto:support@askceo.ai">support@askceo.ai</a></li>
      </ul>
    </div>
  );
};

export default DisclaimerPage;
